/* KOVALI TITAN-DELUXE — only elements present in the DELUXE template initialize. */
(() => {
  'use strict';
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  class DeluxeGallery extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('[data-kd-track]');
      this.slides = [...this.querySelectorAll('[data-kd-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-kd-thumb]')];
      this.index = 0;
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-kd-prev]')?.addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-kd-next]')?.addEventListener('click', () => this.go(this.index + 1), options);
      this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.go(index), options));
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }, { ...options, passive: true });
      this.querySelectorAll('[data-kd-zoom]').forEach((button, index) => {
        button.addEventListener('click', () => this.open(index, button), options);
      });
      this.querySelector('[data-kd-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
      this.dialog.addEventListener('close', () => { this.opener?.focus({ preventScroll: true }); }, options);
      this.resize = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      });
      this.resize.observe(this.track);
      this.sync();
    }
    go(index) {
      const next = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: reducedMotion() ? 'instant' : 'smooth' });
    }
    sync() {
      const index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / (this.track.clientWidth || 1))));
      this.index = index;
      
      this.thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
      const thumb = this.thumbs[index];
      const rail = thumb.parentElement;
      if (thumb.offsetLeft < rail.scrollLeft || thumb.offsetLeft + thumb.offsetWidth > rail.scrollLeft + rail.clientWidth) {
        rail.scrollTo({ left: thumb.offsetLeft - rail.clientWidth / 2 + thumb.offsetWidth / 2, behavior: reducedMotion() ? 'instant' : 'smooth' });
      }
    }
    open(index, opener) {
      const source = this.slides[index].querySelector('img');
      const image = this.querySelector('[data-kd-lightbox-image]');
      image.src = source.src;
      image.alt = source.alt;
      this.querySelector('[data-kd-lightbox-caption]').textContent = source.alt;
      this.opener = opener;
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else window.open(source.src, '_blank', 'noopener');
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null;
      this.resize?.disconnect(); cancelAnimationFrame(this.frame);
    }
  }
  class DeluxeBonus extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      try { this.variants = JSON.parse(this.querySelector('[data-kd-variants]').textContent); } catch { this.variants = []; }
      this.main = this.closest('product-info');
      this.main?.addEventListener('change', () => this.update(), { signal: this.abort.signal });
      if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
        this.unsubscribe = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, event => {
          if (String(event?.data?.sectionId) === this.main?.dataset.section) this.update();
        });
      }
      this.update();
    }
    update() {
      const id = this.main?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      const isSet = /set|26\s*(?:\+|\/|&|und)\s*28/i.test(variant.title);
      this.querySelector('[data-kd-bonus-copy]').textContent = isSet ? '2 Glasdeckel + 2 Filzschoner' : '1 Glasdeckel + 1 Filzschoner';
      this.querySelector('[data-kd-bonus-value]').textContent = isSet ? '99,60 €' : '49,80 €';
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; this.unsubscribe?.(); }
  }
  if (!customElements.get('kovali-deluxe-gallery')) customElements.define('kovali-deluxe-gallery', DeluxeGallery);
  if (!customElements.get('kovali-deluxe-bonus')) customElements.define('kovali-deluxe-bonus', DeluxeBonus);
  function initHeat(root=document) {
    root.querySelectorAll('[data-kd-heat]').forEach(el=>{
      if(el.dataset.ready)return;el.dataset.ready='true';
      let paused=false,visible=true;const button=el.querySelector('[data-kd-heat-toggle]');
      const update=()=>{el.dataset.paused=String(paused||!visible);button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'Animation fortsetzen':'Animation pausieren'};
      button.addEventListener('click',()=>{paused=!paused;update()});
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update()},{threshold:.1});observer.observe(el);update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initHeat(),{once:true});else initHeat();
  document.addEventListener('shopify:section:load',event=>initHeat(event.target));
  class DeluxeShowcase extends HTMLElement {
    connectedCallback(){
      if(this.abort)return;this.abort=new AbortController();const opts={signal:this.abort.signal};
      this.panels=[...this.querySelectorAll('[data-kd-scene]')];this.buttons=[...this.querySelectorAll('[data-kd-scene-choice]')];this.pauseButton=this.querySelector('[data-kd-scene-pause]');this.index=0;this.visible=false;this.paused=reducedMotion();
      this.buttons.forEach((button,index)=>button.addEventListener('click',()=>{this.select(index);this.restart()},opts));
      this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.restart()},opts);
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');this.motion.addEventListener('change',()=>{this.paused=this.motion.matches;this.restart()},opts);
      document.addEventListener('visibilitychange',()=>this.restart(),opts);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.restart()},{threshold:.2});this.observer.observe(this);this.restart();
    }
    select(index){this.index=index;this.panels.forEach((panel,i)=>{panel.classList.toggle('is-active',i===index);panel.setAttribute('aria-hidden',String(i!==index))});this.buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)))}
    restart(){clearInterval(this.timer);const running=this.visible&&!this.paused&&!document.hidden;this.dataset.paused=String(!running);this.pauseButton.setAttribute('aria-pressed',String(this.paused));this.pauseButton.textContent=this.paused?'Animation starten':'Animation pausieren';if(running)this.timer=setInterval(()=>this.select((this.index+1)%this.panels.length),6000)}
    disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.abort?.abort();this.abort=null}
  }
  if(!customElements.get('kovali-deluxe-showcase'))customElements.define('kovali-deluxe-showcase',DeluxeShowcase);
})();
